import { Fragment } from 'react';
import cn from 'classnames';
import { SchedulerDayColumn } from '@lp/features/Scheduler/types';
import { baseCellClassname, stickyShadowStyles } from '@lp/features/Scheduler/constants';
import { useCSOnCallDayTotalsMap } from '@lp/features/Scheduler/SchedulerClinicalSpecialists/components/CSSchedulerTable/hooks';
import { ORGAN_ICON } from '@/utils/helpers';
import { OrganTypeWithoutKidney } from '@/api/apis/case';
import { CSResource, CSResourcesWithShifts } from '@/api/apis/resources/schedule';

// TMDXLP-14091: Kidneys hidden from Schedule Hub Totals. Revert OrganTypeWithoutKidney -> OrganType to restore.
const OrganList = Object.values(OrganTypeWithoutKidney);

const stickyCellClassname = cn('sticky left-0 px-3 bg-white border-none z-2', stickyShadowStyles);

type CSOnCallTotalsSubTableProps = {
  dayCols: SchedulerDayColumn[];
  userList: CSResource[];
  shiftsData: CSResourcesWithShifts;
  hubIds: string[];
};

export const CSOnCallTotalsSubTable = ({ dayCols, userList, shiftsData, hubIds }: CSOnCallTotalsSubTableProps) => {
  const daysTotalsMap = useCSOnCallDayTotalsMap(dayCols, userList, shiftsData, hubIds);

  return (
    <>
      <tr key="totalOnCallRow">
        <td className={cn('h-9', stickyCellClassname)}>
          <span className="text-m-m text-base-5">Total On Call</span>
        </td>
        {dayCols.map((column) => (
          <td
            key={column.key}
            className={cn('text-m-m text-base-5 text-end', baseCellClassname, { 'bg-base-70!': column.isSelectedDay })}
          >
            <span>{daysTotalsMap.get(column.key)?.total}</span>
          </td>
        ))}
      </tr>
      {OrganList.map((organType) => {
        const OrganIcon = ORGAN_ICON[organType] ?? Fragment;

        return (
          <tr key={`${organType}OnCallRow`}>
            <td className={cn('h-5', stickyCellClassname)}>
              <div className="flex gap-2 items-center">
                <OrganIcon className="text-base-30 size-4" />
                <span className="text-s-r text-base-10">{organType}</span>
              </div>
            </td>
            {dayCols.map((column) => (
              <td
                key={column.key}
                className={cn('text-s-m text-base-10 text-end', baseCellClassname, {
                  'bg-base-70!': column.isSelectedDay,
                })}
              >
                <span>{daysTotalsMap.get(column.key)?.[organType]}</span>
              </td>
            ))}
          </tr>
        );
      })}
    </>
  );
};
